import SimpleParallax from 'simple-parallax-js/vanilla';

const initSimpleParallax = (els, options = {}) => {
  return new SimpleParallax(els, options);
};

export default initSimpleParallax;
